import { createFileRoute } from '@tanstack/react-router';
import { MemoryPage } from '@/pages/MemoryPage';

export const Route = createFileRoute('/_authed/memory')({
  component: MemoryPage,
});
